const normaliser = (valeur) => String(valeur || '').trim();

export const sportClub = (club) => normaliser(club?.sport || club?.sports || club?.activite) || 'Autre';

export function normaliserRemiseGenerale(valeur) {
  if (valeur === '' || valeur == null) return null;
  const nombre = Number(valeur);
  if (!Number.isFinite(nombre) || nombre < 0 || nombre > 100) {
    throw new Error('La remise générale doit être comprise entre 0 et 100 %.');
  }
  return Math.round(nombre * 100) / 100;
}

export function etatBoutique(campagne, maintenant = new Date()) {
  if (!campagne) return { code: 'FERMEE', label: 'FERMÉE', force: false };
  const force = normaliser(campagne.statut_force || 'AUTO').toUpperCase();
  if (force === 'EN_LIGNE') return { code: 'EN_LIGNE', label: 'EN LIGNE', force: true };
  if (force === 'HORS_LIGNE') return { code: 'FERMEE', label: 'HORS LIGNE', force: true };
  const instant = maintenant instanceof Date ? maintenant.getTime() : new Date(maintenant).getTime();
  const ouverture = new Date(campagne.ouverture_at).getTime();
  const fermeture = new Date(campagne.fermeture_at).getTime();
  if (Number.isFinite(ouverture) && instant < ouverture) return { code: 'A_VENIR', label: 'À VENIR', force: false };
  if (Number.isFinite(fermeture) && instant > fermeture) return { code: 'FERMEE', label: 'FERMÉE', force: false };
  return { code: 'EN_LIGNE', label: 'EN LIGNE', force: false };
}

export function lieuCampagne(campagne, points = [], magasins = []) {
  if (!campagne?.retrait_autorise) return '';
  return normaliser(campagne.lieu_retrait_libre)
    || normaliser(magasins.find((m) => String(m.id) === String(campagne.magasin_retrait_id))?.nom)
    || normaliser(points.find((p) => String(p.id) === String(campagne.point_retrait_id))?.nom);
}

export function controleParametrage({ campagne, club, produits = [], points = [], parametres }) {
  const manquants = [];
  if (!normaliser(campagne?.nom_boutique || campagne?.nom)) manquants.push('Informations générales');
  if (!sportClub(club)) manquants.push('Sport du club');
  if (!campagne?.ouverture_at || !campagne?.fermeture_at) manquants.push('Statut et dates');
  if (campagne?.retrait_autorise && (!lieuCampagne(campagne, points) || !campagne?.livraison_prevue)) manquants.push('Retrait');
  if (!produits.some((p) => p.visible !== false)) manquants.push('Produits');
  if (!parametres || parametres.statut_paiement === 'NON_CONFIGURE') manquants.push('Paiement');
  return { pret: manquants.length === 0, manquants };
}

export function boutiquesParSport(clubs = [], campagnes = [], recherche = '', filtreSport = 'TOUS', maintenant = new Date()) {
  const terme = normaliser(recherche).toLocaleLowerCase('fr');
  const filtre = normaliser(filtreSport).toLocaleLowerCase('fr');
  const clubsUniques = [...new Map(clubs.map((club) => [
    `${normaliser(club?.groupe_slug).toLocaleLowerCase('fr')}:${String(club?.id || club?.identifiant)}`,
    club,
  ])).values()];
  return clubsUniques.map((club) => {
    const id = String(club.id || club.identifiant);
    const candidates = campagnes.filter((c) => String(c.club_id) === id).sort((a, b) => {
      const fermetureA = new Date(a.fermeture_at).getTime();
      const fermetureB = new Date(b.fermeture_at).getTime();
      return (Number.isFinite(fermetureA) ? fermetureA : Number.POSITIVE_INFINITY)
        - (Number.isFinite(fermetureB) ? fermetureB : Number.POSITIVE_INFINITY);
    });
    const campagne = candidates.find((c) => etatBoutique(c, maintenant).code === 'EN_LIGNE') || candidates[0] || null;
    return { club, campagne, sport: sportClub(club), etat: campagne ? etatBoutique(campagne, maintenant) : { code: 'FERMEE', label: 'FERMÉE', force: false } };
  }).filter(({ club, sport }) => (!terme || normaliser(club.nom).toLocaleLowerCase('fr').includes(terme)) && (filtre === 'tous' || sport.toLocaleLowerCase('fr') === filtre))
    .sort((a, b) => a.sport.localeCompare(b.sport, 'fr') || normaliser(a.club.nom).localeCompare(normaliser(b.club.nom), 'fr'));
}
